module.exports = __webpack_public_path__ + "img/output_9.322844de.png";